module.exports = __webpack_public_path__ + "static/img/ll.081942b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ll.png
// module id = nQ2u
// module chunks = 0